(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  const announcementBar = document.querySelector('.announcement-bar');

  if (announcementBar) {
    const resizeObserver = new ResizeObserver(([entry]) => {
      if (!entry?.borderBoxSize[0]) return;

      const height = Math.round(entry.borderBoxSize[0].blockSize);
      document.body.style.setProperty('--announcements-height', `${height}px`);
    });

    resizeObserver.observe(announcementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
